module.exports = __webpack_public_path__ + "img/nav-logo.f4a8d4f5.png";